module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS1maWxlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRjb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgPHBhdGggZD0iTTYgMiBMNiAzMCAyNiAzMCAyNiAxMCAxOCAyIFogTTE4IDIgTDE4IDEwIDI2IDEwIiAvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-file.svg
// module id = dE83
// module chunks = 50